module.exports = __webpack_public_path__ + "img/etditionPerm.f6667f55.png";